import * as React from 'react';
import * as s from './hint.scss';

export const TOUR_HINT_WRAPPER_ID = 'tour-hint-wrapper';

export interface TourHintWrapperProps {
  show: boolean;
  simulateClick?: boolean;
}

export class TourHintWrapper extends React.Component<
  TourHintWrapperProps,
  any
> {
  render() {
    return (
      <div id={TOUR_HINT_WRAPPER_ID} className={s.tourHintWrapper}>
        {this.props.show && (
          <div
            className={`${s.introHint} ${
              this.props.simulateClick ? s.introHintClick : ''
            }`}
          ></div>
        )}
      </div>
    );
  }
}
